import {httpCall, httpMethod} from "../../service";
import {getLastElementOr} from "../../utils";

export const newVersion = (app, versionData) => {
	debugger;
	return httpCall(httpMethod.POST, `/${app}/version`, versionData);
};

export const loadVersion = app => {
	return (
		httpCall(httpMethod.GET, `/${app}/version`)
			.then( oneItemList => {
				try {
					if( !oneItemList || !oneItemList.data ) return Promise.reject('Empty DB');
					oneItemList.data.reduce(getLastElementOr, null);
				}
				catch (e) {
					return Promise.reject( e );
				}
			})
			.catch( e => Promise.reject( e ) )
	);
};

export const loadAllVersion = app => httpCall(httpMethod.GET, `/${app}/versions`);

export const eraseVersion = (app, version) => httpCall(httpMethod.DELETE, `/${app}/version/${ version }`);
